import { getExecEndpoint } from '../../../service/getExecEndpoint';
import { defaultServer } from '~/api/def/servers/defaultServer';

export const documentRestatedEndpoint = {
  server: defaultServer,
  path: 'documents/restate',
  description: 'Run document extraction',
};

const endpointRunDocumentExtractionGetExec =
  getExecEndpoint<DocumentRestatedEndpointDef>(documentRestatedEndpoint);
export const documentRestatedEndpointPOST = async (
  urlExtra: string,
  payload: DocumentRestatedRequest,
) =>
  endpointRunDocumentExtractionGetExec<'POST'>({
    method: 'POST',
    urlExtra: urlExtra,
    payload: payload,
  });
export interface DocumentRestatedEndpointDef {
  endpoint: typeof documentRestatedEndpoint;
  methods: {
    POST: {
      response: DocumentRestatedResponse;
      payload: DocumentRestatedRequest;
    };
  };
}

export interface DocumentRestatedRequest {
  restated: boolean;
  documentId: string;
}

export type DocumentRestatedResponse =
  | {
      success: true;
    }
  | {
      success: false;
      error?: string;
    };
